import React, { FC } from 'react'

import { IconIotProps } from './IconIot.types'
import * as Styled from './styles/IconIot.style'

import { nonThemeableRules } from '../../ruleSet'

const IconIot: FC<IconIotProps> = ({
  size = nonThemeableRules.defaultSize as number as IconIotProps['size'],
  isResponsive = false,
}: IconIotProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path d='M24 29.031v6.903' stroke='#0D0D0D' strokeLinecap='round' strokeMiterlimit='10' strokeWidth='2' />
        <path
          d='M30.77 12.633c-1.52-3.836-5.372-6.664-9.473-6.664-4.75 0-8.469 3.816-9.18 8.55h.012C9.105 15.427 7 18.396 7 21.75c0 4.023 3.48 7.29 7.5 7.29h18.168c4.5 0 8.152-3.645 8.16-8.15 0-4.5-2.77-8.386-8.633-8.386a7.56 7.56 0 0 0-1.422.133l-.003-.004Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M29 29.031v5.043a1.999 1.999 0 0 0 2 1.989h2.148m-18.281 0h2.149a1.996 1.996 0 0 0 2-1.989v-5.043'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M14.867 36.031a3 3 0 1 1-6.001-.001 3 3 0 0 1 6.001.001Zm12.137 3a3 3 0 1 1-6.002-.001 3 3 0 0 1 6.002.001Zm12.136-3a3 3 0 1 1-6-.001 3 3 0 0 1 6 .001Z'
          stroke='#E60000'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconIot
